import { z } from '@uturn/portal/zod';

export const inviteCarrierSchema = z.object({
	contactOrganisationName: z.string().trim().min(1),
	contactName: z.string().trim().min(1),
	contactEmail: z.string().trim().email(),
	inviteMessage: z.string().trim().optional(),
});

export type InviteCarrierFormValues = z.infer<typeof inviteCarrierSchema>;
